import helperFunctions from '../../utils/helperFunctions';

export const createQuotePayload = ({ rootState, state }) => {
  const { user, route } = rootState;

  const payload = {
    customer: {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.emailAddress,
      mobilePhone: user.phoneNumber,
      phone: user.phoneNumber,
      payload: {
        dateOfBirth: helperFunctions.birthdateShaper(user.birthdate),
        maritalStatus: state.insurance.maritalStatus.toLowerCase(),
        gender: state.insurance.gender.toLowerCase(),
        kmToWork: parseInt(state.insurance.distance, 10),
        winterTires: state.insurance.hasWinterTires === 'Yes' ? 'Y' : 'N',
      },
      address: {
        address_line_1: user.streetAddress || null,
        address_line_2: user.unit || null,
        city: user.city || null,
        province_id: user.stateCode || null,
        country_code: user.country || 'CA',
        postal_code: user.postalCode || user.zipCode,
      },
    },
    vehicle: {
      year: state.insurance.insuranceVehicle.year,
      make: state.insurance.insuranceVehicle.make,
      model: state.insurance.insuranceVehicle.model,
      trim: '',
      style: [],
      mileage: 15000,
      // calling from query instead of store since we only use it once when we complete the Quote.
      vin: route.query.vin || null,
    },
    purchasePrice: parseInt(state.insurance.price, 10),
    referrerUrl: route.query.referrer_url ? route.query.referrer_url : '',
  };

  return Object.freeze(payload);
};

export const createLeadCustomerInsurancePayload = ({ user, insurance }) => {
  const payload = {
    dateOfBirth: helperFunctions.birthdateShaper(user.birthdate),
    maritalStatus: insurance.insurance.maritalStatus ? insurance.insurance.maritalStatus.toLowerCase() : null,
    gender: insurance.insurance.gender ? insurance.insurance.gender.toLowerCase() : null,
    kmToWork: insurance.insurance.distance ? parseInt(insurance.insurance.distance, 10) : null,
    winterTires: insurance.insurance.hasWinterTires === 'Yes' ? 'Y' : 'N',
  };
  return Object.freeze(payload);
};
